module.exports = __webpack_public_path__ + "img/img (22).fbd779ed.jpg";